import { createSelector } from "@reduxjs/toolkit";

export const singleOwnerState = (state) => state.singleOwner;

export const singleOwnerSelectors = createSelector(singleOwnerState, (state) => state);
